(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-select"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-select"], factory);
	else if(typeof exports === 'object')
		exports["ReactObjectForm"] = factory(require("react"), require("react-select"));
	else
		root["ReactObjectForm"] = factory(root["React"], root["Select"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PropertyConfig = exports.BaseFormRenderer = exports.MultiSelectRenderer = exports.SelectRenderer = exports.ObjectFormRenderer = exports.FieldRenderer = exports.NumberValueInput = exports.BooleanValueInput = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(3);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _GenericValueInput = __webpack_require__(4);

var _GenericValueInput2 = _interopRequireDefault(_GenericValueInput);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//Workaround. See -> https://phabricator.babeljs.io/T6777
 true ? 'undefined' : _typeof(undefined);
var console = console ? console : {};
console.log = console.log ? console.log : function () {};

//TODO: Make all components configurable by checking for component override via config

var InternalObjectValuePropType = _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.string])]);

//Base shape for property config
var PropertyConfig = {
    //Property key in Object
    name: _propTypes2.default.string.isRequired,
    //If property is a child-object configs for its properties can be supplied
    config: _propTypes2.default.arrayOf(_propTypes2.default.shape(PropertyConfig)),
    //Possible values for this property
    options: _propTypes2.default.array,
    //true if property can contain values which are not listed in "options"
    allowCustomValues: _propTypes2.default.bool,
    //true if form field should be read-only
    disabled: _propTypes2.default.bool,
    clearable: _propTypes2.default.bool,
    resetValue: _propTypes2.default.shape({ label: _propTypes2.default.string, option: InternalObjectValuePropType }),
    placeholder: _propTypes2.default.string,
    label: _propTypes2.default.string,
    //TODO: concept / implement
    validator: _propTypes2.default.func,
    caption: _propTypes2.default.string,
    changeHandler: _propTypes2.default.func,
    hide: _propTypes2.default.bool,
    trim: _propTypes2.default.bool
};

var ReactObjectForm = function (_React$Component) {
    _inherits(ReactObjectForm, _React$Component);

    function ReactObjectForm() {
        _classCallCheck(this, ReactObjectForm);

        return _possibleConstructorReturn(this, (ReactObjectForm.__proto__ || Object.getPrototypeOf(ReactObjectForm)).apply(this, arguments));
    }

    _createClass(ReactObjectForm, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                object = _props.object,
                config = _props.config,
                id = _props.id,
                rest = _objectWithoutProperties(_props, ['object', 'config', 'id']);

            var configtmp = {};
            configtmp.config = config;
            //obey PropTypes
            configtmp.name = id ? id : 'react-object';
            configtmp = Object.assign({}, config, configtmp);
            return _react2.default.createElement(
                'form',
                { className: configtmp.name + '-form' },
                _react2.default.createElement(BaseFormRenderer, _extends({}, rest, configtmp, { id: configtmp.name, object: object }))
            );
        }
    }]);

    return ReactObjectForm;
}(_react2.default.Component);

var BooleanValueInput = function BooleanValueInput(_ref) {
    var value = _ref.value,
        id = _ref.id,
        name = _ref.name,
        changeHandler = _ref.changeHandler,
        disabled = _ref.disabled,
        rest = _objectWithoutProperties(_ref, ['value', 'id', 'name', 'changeHandler', 'disabled']);

    var internalChangeHandler = function internalChangeHandler(event) {
        return changeHandler(event.target.checked);
    };
    return _react2.default.createElement('input', _extends({}, rest, {
        id: id + '-input',
        className: (disabled ? 'disabled' : '') + ' form-control boolean-value-input',
        type: 'checkbox',
        checked: value ? 'checked' : null,
        value: name,
        name: name,
        onChange: internalChangeHandler,
        disabled: disabled ? 'disabled' : null }));
};
exports.BooleanValueInput = BooleanValueInput;

var NumberValueInput = exports.NumberValueInput = function (_React$Component2) {
    _inherits(NumberValueInput, _React$Component2);

    function NumberValueInput(props) {
        _classCallCheck(this, NumberValueInput);

        var _this2 = _possibleConstructorReturn(this, (NumberValueInput.__proto__ || Object.getPrototypeOf(NumberValueInput)).call(this, props));

        _this2.state = { value: props.value };
        _this2.numberParsingChangeHandler = _this2.numberParsingChangeHandler.bind(_this2);
        return _this2;
    }

    _createClass(NumberValueInput, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(next) {
            if (next.value != this.state.value) {
                this.setState({ value: next.value });
            }
        }
    }, {
        key: 'numberParsingChangeHandler',
        value: function numberParsingChangeHandler(value) {
            this.setState({ value: value });
            var parsed = Number.parseFloat(value);
            if (Number.isFinite(parsed)) {
                this.props.changeHandler(parsed);
            } else if (value === '') {
                this.setState({ value: Number.NaN });
                this.props.changeHandler(Number.NaN);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                value = _props2.value,
                rest = _objectWithoutProperties(_props2, ['value']);

            return _react2.default.createElement(_GenericValueInput2.default, _extends({}, rest, {
                value: Number.isNaN(value) ? '' : this.state.value,
                changeHandler: this.numberParsingChangeHandler }));
        }
    }]);

    return NumberValueInput;
}(_react2.default.Component);

var FieldRenderer = function FieldRenderer(_ref2) {
    var name = _ref2.name,
        id = _ref2.id,
        object = _ref2.object,
        caption = _ref2.caption,
        label = _ref2.label,
        rest = _objectWithoutProperties(_ref2, ['name', 'id', 'object', 'caption', 'label']);

    //Use capitalized field name as label if not set
    var labelString = void 0;
    if (label) {
        labelString = label;
    } else {
        var _name = _toArray(name),
            firstLetter = _name[0],
            _rest = _name.slice(1);

        labelString = firstLetter.toLocaleUpperCase() + _rest.join('');
    }

    return _react2.default.createElement(
        'div',
        { className: 'form-group' },
        _react2.default.createElement(
            'label',
            null,
            labelString
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(BaseFormRenderer, _extends({}, rest, { id: id, name: name, object: object })),
            _react2.default.createElement(
                'span',
                null,
                caption
            )
        )
    );
};
exports.FieldRenderer = FieldRenderer;
var ObjectFormRenderer = function ObjectFormRenderer(_ref3) {
    var object = _ref3.object,
        config = _ref3.config,
        changeHandler = _ref3.changeHandler,
        id = _ref3.id,
        rest = _objectWithoutProperties(_ref3, ['object', 'config', 'changeHandler', 'id']);

    var childConfig = function childConfig(name) {
        return config ? config.find(function (currentConfig) {
            return currentConfig.name === name;
        }) : null;
    };

    var createChildChangeHandler = function createChildChangeHandler(name) {
        return function (newObjectValue) {
            if (childConfig(name) && childConfig(name).hasOwnProperty('changeHandler') && 'function' == typeof childConfig(name).changeHandler) {
                childConfig(name).changeHandler(newObjectValue, changeHandler);
            } else {
                var changedObject = Object.assign({}, object);
                changedObject[name] = newObjectValue;
                changeHandler(changedObject);
            }
        };
    };
    //add configured fields in configured order
    var objectFields = Object.keys(object);
    var fields = config ? config.map(function (c) {
        return c.name;
    }) : [];
    //add remaining fields without config
    objectFields.forEach(function (f) {
        if (!fields.includes(f)) {
            fields.push(f);
        }
    });

    fields = fields.filter(function (name) {
        var currchildConfig = childConfig(name);
        if (!currchildConfig) {
            return true;
        }
        return !currchildConfig.hide;
    }).map(function (childPropertyName) {
        var childPropertyConfig = childConfig(childPropertyName);
        var prefix = id && id != '' ? id + '-' : id;
        return _react2.default.createElement(FieldRenderer, _extends({}, rest, childPropertyConfig, {
            key: childPropertyName,
            id: prefix + childPropertyName,
            name: childPropertyName,
            object: object[childPropertyName],
            changeHandler: createChildChangeHandler(childPropertyName) }));
    });

    return _react2.default.createElement(
        'fieldset',
        { id: id + '-fieldset' },
        fields
    );
};
exports.ObjectFormRenderer = ObjectFormRenderer;
var SelectRenderer = function SelectRenderer(_ref4) {
    var value = _ref4.value,
        options = _ref4.options,
        id = _ref4.id,
        changeHandler = _ref4.changeHandler,
        allowCustomValues = _ref4.allowCustomValues,
        multi = _ref4.multi,
        placeholder = _ref4.placeholder,
        resetValue = _ref4.resetValue,
        rest = _objectWithoutProperties(_ref4, ['value', 'options', 'id', 'changeHandler', 'allowCustomValues', 'multi', 'placeholder', 'resetValue']);

    var internalChangeHandler = function internalChangeHandler(values) {
        if (values) {
            if (Array.isArray(values)) {
                changeHandler(values.map(function (value) {
                    return value.value ? value.value : null;
                }));
            } else {
                changeHandler(values.value ? values.value : null);
            }
        }
    };

    //transform options if not in correct form
    var transformedOptions = options.map(function (option) {
        return (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' ? option : { label: option, value: option };
    });

    //default behaviour of react-select is to use clearable = true, but to make this work a resetValue
    //in the correct format is needed


    return _react2.default.createElement(_reactSelect2.default, _extends({}, rest, {
        options: transformedOptions,
        name: id + '-select',
        value: value,
        onChange: internalChangeHandler,
        multi: multi,
        resetValue: resetValue ? resetValue : { label: '', value: null },
        allowCreate: allowCustomValues,
        placeholder: placeholder ? placeholder : 'Select..'
    }));
};

exports.SelectRenderer = SelectRenderer;
var MultiSelectRenderer = function MultiSelectRenderer(_ref5) {
    var value = _ref5.value,
        rest = _objectWithoutProperties(_ref5, ['value']);

    return _react2.default.createElement(SelectRenderer, _extends({}, rest, { value: value, multi: true }));
};

exports.MultiSelectRenderer = MultiSelectRenderer;
var BaseFormRenderer = function BaseFormRenderer(_ref6) {
    var object = _ref6.object,
        config = _ref6.config,
        name = _ref6.name,
        options = _ref6.options,
        Component = _ref6.component,
        rest = _objectWithoutProperties(_ref6, ['object', 'config', 'name', 'options', 'component']);

    //TODO: handle explicitly configured inputs
    if (Component) {
        return _react2.default.createElement(Component, _extends({}, rest, { value: object, name: name, config: config }));
    }

    //handle generic cases
    var valueType = typeof object === 'undefined' ? 'undefined' : _typeof(object);

    if (options && Array.isArray(options)) {
        return _react2.default.createElement(SelectRenderer, _extends({}, rest, config, { value: object, name: name, options: options }));
    }

    if (object === null && !options) {
        return _react2.default.createElement(_GenericValueInput2.default, _extends({ trim: true }, rest, config, { value: '', name: name }));
    }
    switch (valueType) {
        case 'number':
            return _react2.default.createElement(NumberValueInput, _extends({}, rest, config, { value: object, name: name }));
        case 'object':
            if (Array.isArray(object)) {
                return _react2.default.createElement(MultiSelectRenderer, _extends({}, rest, config, { value: object, name: name, options: options ? options : [] }));
            }
            return _react2.default.createElement(ObjectFormRenderer, _extends({}, rest, {
                config: config,
                object: object, name: name }));
        case 'boolean':
            return _react2.default.createElement(BooleanValueInput, _extends({}, rest, config, { value: object, name: name }));

        case 'string':
            //if there are options configured, use SelectRenderer
            if (options && Array.isArray(options)) {
                return _react2.default.createElement(SelectRenderer, _extends({}, rest, config, { value: object, name: name, options: options }));
            }
            return _react2.default.createElement(_GenericValueInput2.default, _extends({ trim: true }, rest, config, { value: object, name: name }));
        default:
            return _react2.default.createElement(_GenericValueInput2.default, _extends({ trim: true }, rest, config, { value: object, name: name }));

    }
};
exports.BaseFormRenderer = BaseFormRenderer;
exports.default = ReactObjectForm;
exports.PropertyConfig = PropertyConfig;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(5)();
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ReactObjectForm = __webpack_require__(0);

var _ReactObjectForm2 = _interopRequireDefault(_ReactObjectForm);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericValueInput = function (_React$Component) {
    _inherits(GenericValueInput, _React$Component);

    function GenericValueInput(props) {
        _classCallCheck(this, GenericValueInput);

        var _this = _possibleConstructorReturn(this, (GenericValueInput.__proto__ || Object.getPrototypeOf(GenericValueInput)).call(this, props));

        _this.internalChangeHandler = _this.internalChangeHandler.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        return _this;
    }

    _createClass(GenericValueInput, [{
        key: 'internalChangeHandler',
        value: function internalChangeHandler(event) {
            var returnValue = event.target.value;
            if (returnValue === '') {
                returnValue = null;
            }
            this.props.changeHandler(returnValue);
        }
    }, {
        key: 'onBlur',
        value: function onBlur() {
            if (this.props.trim) {
                var returnValue = this.props.value ? this.props.value.trim() : null;

                this.internalChangeHandler({ target: { value: returnValue } });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                value = _props.value,
                id = _props.id,
                placeholder = _props.placeholder,
                disabled = _props.disabled;

            return _react2.default.createElement('input', {
                id: id + '-input',
                className: (disabled ? 'disabled' : '') + ' form-control generic-value-input',
                type: 'text',
                value: value,
                onChange: this.internalChangeHandler,
                onBlur: this.onBlur,
                placeholder: placeholder,
                disabled: disabled ? 'disabled' : null
            });
        }
    }]);

    return GenericValueInput;
}(_react2.default.Component);

exports.default = GenericValueInput;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(7);
var ReactPropTypesSecret = __webpack_require__(8);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// ReactObjectForm.min.js